<template>
  <div class="modal fade show custom-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="exampleModalLabel">{{ title }}</h4>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal"><i
              class="fa fa-window-close text-danger"></i></button>
        </div>
        <div class="modal-body">
          <slot name="modal-body"></slot>
        </div>
        <div v-if="hasFooter" class="modal-footer">
          <slot name="modal-footer">
            <button type="button" class="btn btn-success" @click="closeModal">{{$t('close.text')}}</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: "Title Here"
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  }
}
</script>

<style scoped>
.custom-modal {
  background-color: #00000073;
  padding-right: 16px;
  display: block;
}
</style>
